"use client";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { FlexBox } from "src/lib/components/salify-next-layout/default/components/flex-box";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import PinterestIcon from "@mui/icons-material/Pinterest";
import InstagramIcon from "@mui/icons-material/Instagram";
import React from "react";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import { layoutConstant } from "src/lib/utils/constants";
import SalifyLink from "src/lib/components/link/salify-link";

export interface VariantProps {
  socialItems: Array<{
    type: "facebook" | "twitter" | "youtube" | "pinterest" | "instagram";
    url: string;
  }>;
  pageLinks?: Array<{
    label: string;
    action: string;
    target: string;
  }>;
}

const ICON_MAPPING: {
  [key in "facebook" | "twitter" | "youtube" | "pinterest" | "instagram"]: any;
} = {
  facebook: FacebookIcon,
  twitter: TwitterIcon,
  youtube: YouTubeIcon,
  pinterest: PinterestIcon,
  instagram: InstagramIcon,
};

const FooterSimple: React.FC<VariantProps> = (props) => {
  const SocialLinks = () => {
    if (!props.socialItems.length) {
      return null;
    }
    return (
      <FlexBox className="flex" mx={-0.625}>
        {props.socialItems.map(({ type, url }, ind) => {
          const Icon = (ICON_MAPPING as any)[type];
          return Icon ? (
            <SalifyLink href={url} key={ind}>
              <Icon
                sx={{
                  fontSize: 32,
                }}
              />
            </SalifyLink>
          ) : null;
        })}
      </FlexBox>
    );
  };

  const PageLinks = () => {
    if (!props.pageLinks || !props.pageLinks.length) {
      return null;
    }
    return (
      <FlexBox className="flex" gap={2} flexWrap="wrap" justifyContent="center">
        {props.pageLinks.map(({ label, target }, ind) => (
          <SalifyLink href={target} key={ind}>
            {label}
          </SalifyLink>
        ))}
      </FlexBox>
    );
  };

  return (
    <Box
      component="footer"
      bgcolor="white"
      position="sticky"
      bottom={0}
      left={0}
      right={0}
      width="100%"
      zIndex={1000}
      sx={{
        borderTop: "1px solid",
        borderColor: "divider",
        boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.05)",
      }}
    >
      <Box
        component={Container}
        disableGutters
        pt={{
          sm: 1.5,
          xs: 1.5,
        }}
        pb={{
          sm: 1.5,
          xs: 1.5,
        }}
        px={{
          sm: 3,
          xs: 2,
        }}
        overflow="hidden"
      >
        <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
          <Box textAlign="center">
            <SalifyFallback.Label
              path="copyright"
              default="© Simplify Technology 2025. All Rights Reserved."
            />
          </Box>
          <Box>
            <PageLinks />
          </Box>
          <Box>
            <SocialLinks />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FooterSimple;
